<template>
  <layout-report
    :disableNext="!isDone"
    :hasNext="hasNext"
    :showFooter="showFooter"
    :forceNextBtn="forceNextBtn"
    :renderBackAndForthFooter="renderBackAndForthFooter"
    @logoClick="logoClick"
    @next="next"
    @prev="prev"
  >
    <v-row>
      <v-col cols="12" :md="md" class="pb-0">
        <ReportHeader
          :debug="debug"
          :description="description"
          :image="imageFromAssetRepository"
          :hasInstructions="hasInstructions"
          :instructionPictures="instructionPictures"
          :instructionText="instructionText"
          :instructionTitle="instructionTitle"
          :title="title"
          :imageHeight="imageHeight"
        >
          <slot name="header"></slot>
        </ReportHeader>
      </v-col>
      <v-col class="pt-md-8 center" cols="12" justify="center" :md="12 - md">
        <slot />
      </v-col>
    </v-row>
    <query-params-list />
  </layout-report>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import LayoutReport from "@/layouts/LayoutReport.vue";
import ReportHeader from "@/components/report/ReportHeader.vue";
import { AssetEnum, AssetRepository } from "@/lib/AssetRepository";
import QueryParamsList from "@/components/settings/QueryParamsList.vue";

@Component({
  components: {
    LayoutReport,
    ReportHeader,
    QueryParamsList: QueryParamsList
  }
})
export default class LayoutReportStep extends Vue {
  @Prop({ default: 6 })
  md!: number;

  @Prop({})
  debug!: any;

  @Prop({ default: true })
  showFooter!: boolean;

  @Prop({ default: false })
  forceNextBtn!: boolean;

  @Prop({})
  description!: string;

  @Prop({})
  title!: string;

  @Prop({})
  image!: AssetEnum;

  @Prop({})
  hasInstructions!: boolean;

  @Prop({ default: "Anleitung" })
  instructionTitle!: string;

  @Prop({ default: "Hier ist ein Beispiel wie das Foto am besten aufzunehmen ist." })
  instructionText!: string;

  @Prop()
  instructionPictures!: AssetEnum[];

  @Prop({ default: true })
  isDone!: boolean;

  @Prop({ default: true })
  hasNext!: boolean;

  @Prop()
  imageHeight!: number;

  @Prop({ default: true })
  private renderBackAndForthFooter!: boolean;

  logoClick() {
    this.$emit("logoClick", true);
    this.$log.info("Logo clicked");
  }

  get imageFromAssetRepository() {
    if (this.image) {
      return AssetRepository.getAsset(this.$vuetify.theme.dark, this.image);
    }
    return null;
  }

  next() {
    this.$emit("next");
  }

  prev() {
    this.$emit("prev");
  }
}
</script>

<style></style>
